<div class="page-container">
    <div class="row center-xs">
        <div class="col-xs-12 col-sm-11 col-md-9">
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h1>BOTON FLUTTER</h1>
                            <div class="text-content-bigger">El comercio puede conectarse con nuestra librería flutter
                                en menos de 2 horas.
                                La librería flutter es full dart, permitiendo la integración de cualquier tienda móvil
                                desarrollada en lenguaje de programación dart.
                            </div>
                            <div class="text-content-bigger">El formulario de pago se crea dinámicamente, haciendo
                                segura la captura y el envío de los datos de tarjeta.
                            </div>
                            <!-- <div class="text-content-bigger">El pago es solicitado al procesador de pagos y la respuesta
                                es mostrada al cliente sin errores y sin demoras.
                                El comercio recibe la notificación de autorización de los servidores de epago.
                            </div> -->
                            <!-- <div class="text-content-bigger">Descarga un ejemplo de integración completo al botón de
                                pago web, <a href="https://github.com/synapsolutions/shop-web">visita nuestro link en
                                    git.</a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="img-container">
                        <img class="img" src="assets/img/flutter-cards-button.png">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h2>Instalación</h2>
                            <div class="text-content">La librería flutter es full dart, permitiendo la integración de
                                cualquier tienda móvil desarrollada en lenguaje de dart.
                            </div>
                            
                            <div class="text-content">1. Descargue y descomprima el archivo epago.zip. <br>
                                <a href="https://pay.button.epago.pe/flutter/latest/epago.zip">descárguelo
                                    aquí</a><br>
                            </div>
                            <div class="text-content">2. Cree el directorio "packages" en el
                                proyecto Flutter y copie el directorio "epago" completo del paso anterior.
                            </div>

                            <div class="text-content">3. Incluir la libreria en el pubspec del proyecto Flutter
                            </div>
                            <div class="code-content-sm">
                                <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
                                    style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="b70911494481b6d01cc57d41d8cf450d"
                                    fileName="epago-flutter-pubspec.yaml"></ng-gist>
                            </div>
                        </div>
                        <div class="paragraph">
                            <h2>Configuración</h2>
                            <div class="text-content">1. Importar libreria en la aplicación
                            </div>
                            <div class="code-content-xs">
                                <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
                                    style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="2a7ad56cd3484fcbf1770ffb4b62a1b7"
                                    fileName="epago-flutter-head.dart"></ng-gist>
                            </div>

                            <div class="text-content">2. Inicialice y configure el formulario de pago (visualmente, el
                                ambiente de procesamiento de pago y la gestión visual de la respuesta).
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/1rTuStSk"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="d3115af8f392ce7d6519a41183d6a5f1"
                                    fileName="epago-flutter-cards-startpayment.dart"></ng-gist>
                            </div>
                            <aside class="note">
                                <b>Nota:</b> El mensaje de "Denegación" del procesador se obtiene:<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Código:</b>
                                response.data.result.processorResult.code<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Mensaje:</b>
                                response.data.result.processorResult.message<br>
                                <b>Nota 2:</b> Para revisar el detalle del mensaje de respuesta diríjase a la sección de
                                <a routerLink="/api-events">"API de Eventos"</a><br>
                            </aside>
                            <div class="text-content">3. Setee los datos de la orden o pedido.
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/vx78zaBe"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="6c8831312e38a09401efd27137726292"
                                    fileName="epago-flutter-cards-buildTransaction.dart"></ng-gist>
                            </div>
                            <div class="text-content">4. Setee los datos de autenticación.
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/T9xYvXHR"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="880da3a09d199585ee4684159a1bf8a3"
                                    fileName="epago-flutter-buildAuthentication.dart"></ng-gist>
                            </div>
                            <aside class="note"><b>Nota:</b> El APIKey y SignatureKey están disponibles en la plataforma
                                de gestión de epago
                            </aside>
                            <div class="text-content">5. Las siguientes funciones son utilitarias y deben ser
                                utilizadas solo como "referencia".
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/VPfbEaw1"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="9313e9a2250feeeb2afcb267e281867a"
                                    fileName="epago-flutter-utilities.dart"></ng-gist>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>